/**
 * @Desc 关于我们数据
 * @Author mileS
 * @Date 2020-06-08 15:39
 * */

const dataList = [
  {
    content: '希望一款能够满足中国孩子英语学习需求的产品能够帮助更多孩子走上科学的英语学习之路！' +
      'AI课产品通过Ai智能互动极大地激发了孩子学习英语的兴趣，同时优选外教与科学的课件也让孩子学习到纯正的英语变成可能，更加有利于中教老师提高授课能力与课后服务，帮助孩子提升英文综合能力的同时，也提高了英文成绩，家长的反馈特别好。数据会说话，去年优选课程平均续班率接近94%，当然还有很多提升的空间，我们会再接再厉 ，努力使AI课程让更多孩子受益。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '平舆麦田',
    time: '2019年03月',
    scope: '500 — 1000人',
    mode: 'AI课',
    author: '平舆麦田校长'
  },
  {
    content: '紧跟行业标杆，提升综合能力，成就更多学生在使用产品的过程中，建全了产品体系和产品的深度，提高了老师课堂授课能力和课后服务能力，提升了学生的学习成绩，得到了家长的广泛认可',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '河南爱上课',
    time: '2019年01月',
    scope: '500 — 1000人',
    mode: '双师+AI课',
    author: '河南爱上课校长'
  },
  {
    content: '我经常挂在嘴边的一句话就是多亏引进了AI课，才让我们突破发展的瓶颈期。 AI课是外教课程的新品类和新物种，使用AI课可以赋能机构，帮助机构形成教学产品的差异化，构筑竞争的护城河，我们学校AI课的试听转化率可以达到100%，续班率基本90%。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '和而默教育培训学校',
    time: '2018年09月',
    scope: '500 — 1000人',
    mode: '双师+好课+AI课',
    author: '建德市和而默教育培训学校尤校长'
  },
  {
    content: '与魔法校合作前，我们十几年都没有做过也没听说过运营，一直都是”野蛮生长“的状态，和魔法校合作后，我们的招生和运营逐渐有了体系。未来希望和魔法校一起赢得更好的辉煌。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '邯郸天骄外语学校',
    time: '2019年01月',
    scope: '500 — 1000人',
    mode: '双师+好课',
    author: '邯郸天骄武老师'
  },
  {
    content: '好未来的优秀师资，以及教研、运营的标准化、可复制，这些是我最看重的，像我们这样的三四线城市，几乎所有的培训机构都缺少这些，而未来魔法校毫无保留的把好未来18年的办学经验分享，是真心诚意、全力以赴地在帮助我们这些中小机构。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '大庆智航教育',
    time: '2019年04月',
    scope: '500 — 1000人',
    mode: 'SaaS系统',
    author: '大庆智航教育刘校长'
  },
  {
    content: '我感觉自己就是好未来人，从合作的第一天起，好未来对我们就像直营校一样毫无保留地全力扶持。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '保定拓普教育',
    time: '2020年03月',
    scope: '500 — 1000人',
    mode: '魔法好课',
    author: '保定拓普教育高校长'
  },
  {
    content: '通过魔法好课完善的学科内容体系，强大的教研支持，提升了机构自有教研体系的竞争力，帮助我们机构实现进一步发展。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '武汉优杰教育机构',
    time: '2019年10月',
    scope: '500 — 1000人',
    mode: '魔法好课',
    author: ' 武汉优杰教育校长'
  },
  {
    content: '魔法好课标准的备课流程、高效的教学方法和完整的备授课服务体系，整体提升了我们的教学质量，帮助年轻老师快速成长。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '福州市起点培训中心',
    time: '2019年05月',
    scope: '500 — 1000人',
    mode: '魔法好课',
    author: '福州起点培训中心校长'
  },
  {
    content: '魔法好课的课程体系，完整的运营服务支持以及智能课堂服务系统，让我们的数学教学团队快速成长起来，稳定实现数学扩科。',
    pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_banner2.jpg',
    title: '韩城放飞梦想培训中心',
    time: '2019年05月',
    scope: '500 — 1000人',
    mode: '魔法好课',
    author: '韩城放飞梦想培训中心校长'
  }
]

export { dataList }
